import { InspectionStepId } from '@areapif/areapif-shared'
import {
  mdiClipboardCheckOutline,
  mdiDoorOpen,
  mdiDoorSlidingLock,
  mdiFeatureSearchOutline,
  mdiLockCheckOutline,
  mdiLockOpenCheckOutline,
  mdiPackageVariant,
  mdiTruckCargoContainer,
} from '@mdi/js'

/**
 * Step glyphs, matching the MaterialCommunityIcons the mobile app uses so an
 * operator reads the same symbol in both places.
 */
export const INSPECTION_STEP_ICON_PATHS: Record<InspectionStepId, string> = {
  [InspectionStepId.POSICIONADO]: mdiTruckCargoContainer,
  [InspectionStepId.PRECINTOS_EXISTENTES]: mdiLockOpenCheckOutline,
  [InspectionStepId.APERTURA]: mdiDoorOpen,
  [InspectionStepId.PASILLO]: mdiPackageVariant,
  [InspectionStepId.MERCANCIA_EXTRAIDA]: mdiFeatureSearchOutline,
  [InspectionStepId.CIERRE]: mdiClipboardCheckOutline,
  [InspectionStepId.CONTENEDOR_CERRADO]: mdiDoorSlidingLock,
  [InspectionStepId.PRECINTOS_CIERRE]: mdiLockCheckOutline,
  [InspectionStepId.OTROS]: mdiClipboardCheckOutline,
}
